import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import './ReviewCustomers.css';

const ReviewCutomer = ({ review }) => {
    return (
        <div>
            <container>
                <div className='review-div'>
                    <div>
                        <img className='review-img' src={review.img} alt='' />
                        <p className='review-p'>{review.description}</p>
                    </div>
                    <div className="review-icon">
                        <span><FontAwesomeIcon icon={faStar} style={{marginLeft:20}} /><FontAwesomeIcon icon={faStar} style={{marginLeft:20}} /><FontAwesomeIcon icon={faStar} style={{marginLeft:20}} /><FontAwesomeIcon icon={faStar} style={{marginLeft:20}} /></span>
                        <h6 className='review-h6'>{review.name}</h6>
                        <p className='review-p'>{review.designation}</p>
                    </div>
                </div>
            </container>
        </div>
    );
}

export default ReviewCutomer;
